import { createContext } from 'react';

export const StickyContext = createContext<{
  activeKey?: string;
}>({});
